const stats = [
  { value: "15+", label: "Years of Experience", description: "Delivering IT excellence since 2009" },
  { value: "500+", label: "Clients Served", description: "Across 30+ industries worldwide" },
  { value: "99.9%", label: "Uptime SLA", description: "Guaranteed reliability for critical systems" },
  { value: "24/7", label: "Expert Support", description: "Round-the-clock monitoring & response" },
];

export const Stats = () => {
  return (
    <section className="py-16 px-4 bg-sky-500 dark:bg-sky-600">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center space-y-1">
              <div className="text-4xl md:text-5xl font-bold text-white">{s.value}</div>
              <div className="text-sky-100 font-semibold text-sm md:text-base">{s.label}</div>
              <div className="text-sky-200 text-xs md:text-sm">{s.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
